import { API } from "../constants/api";
import { AxiosInstance } from "../utils/AxiosInstance";

export const getInvestigation = async (investigationId: string = "") => {
  const { data } = await AxiosInstance.get(
    `${API}/v1/investigations/${investigationId}`,
  );
  return data;
};

export const getAllInvestigations = async (
  pagination: { pageSize: number; current: number },
  filter: string = "",
  additionalFilters: {
    is_active?: string;
    status?: string;
    legal_type?: string;
  } = {},
) => {
  const params: Record<string, string | number> = {
    limit: pagination.pageSize,
    offset: (pagination.current - 1) * pagination.pageSize,
  };

  if (filter) {
    params.filter = filter;
  }

  if (additionalFilters.is_active) {
    params.is_active = additionalFilters.is_active;
  }

  if (additionalFilters.status) {
    params.status = additionalFilters.status;
  }

  if (additionalFilters.legal_type) {
    params.legal_type = additionalFilters.legal_type;
  }

  const { data } = await AxiosInstance.get(`/v1/investigations/`, {
    params,
  });
  return data;
};

export const getAllOrganizationInvestigation = async (
  pagination: any,
  filter: string = "",
) => {
  const { data } = await AxiosInstance.get(
    `/v1/investigations/organization?filter=${filter}`,
    {
      params: {
        limit: pagination.pageSize,
        offset: (pagination.current - 1) * pagination.pageSize,
      },
    },
  );
  return data;
};

export const createInvestigation = async (
  legal_type: string,
  prospectus_email: string,
  report_types: string[],
) => {
  const { data } = await AxiosInstance.post(`/v1/investigations/new`, {
    legal_type: legal_type,
    prospectus_email: prospectus_email,
    report_types: report_types,
  });
  return data;
};

export const enableInvestigation = async (investigationId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/investigations/${investigationId}/enable`,
  );
  return data;
};

export const disableInvestigation = async (investigationId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/investigations/${investigationId}/disable`,
  );
  return data;
};

export const downloadMultireport = async (investigationId: string) => {
  return await AxiosInstance.get(
    `/v1/investigations/${investigationId}/download/multireport`,
    {
      responseType: "blob",
    },
  );
};

export const downloadCreditReport = async (investigationId: string) => {
  return await AxiosInstance.get(
    `/v1/investigations/${investigationId}/download/credit-report`,
    {
      responseType: "blob",
    },
  );
};

export const downloadCreditReportMetadata = async (investigationId: string) => {
  return await AxiosInstance.get(
    `/v1/investigations/${investigationId}/download/metadata`,
    {
      responseType: "blob",
    },
  );
};

export const sendMultireport = async (investigationId: string) => {
  const { data } = await AxiosInstance.post(
    `/v1/investigations/${investigationId}/send/multireport`,
  );
  return data;
};

export const sendCreditReport = async (investigationId: string) => {
  const { data } = await AxiosInstance.post(
    `/v1/investigations/${investigationId}/send/credit-report`,
  );
  return data;
};

export const sendMetadata = async (investigationId: string) => {
  const { data } = await AxiosInstance.post(
    `/v1/investigations/${investigationId}/send/metadata`,
  );
  return data;
};
